import { styled } from "styled-components";

import Section, { StyledSectionImage } from "../molecules/Section";
import SectionTitle from "../atoms/SectionTitle";

import SkillsImage from "../../assets/icons/skills.svg";

const Skills = () => {
  return (
    <Section id="skills">
      <SectionTitle title="skills" />
      <StyledSectionImage src={SkillsImage} alt="" />

      <StyledDetailsWrapper>
        <StyledDetailsContainer>
          <StyledSummary>FOR EVERYDAY WORK</StyledSummary>
          <StyledDetailsParagraph>
            javascript • typescript • react • nextjs • react native • vue • nuxt • rest api • graphql •
            redux • git • scss • styled components • tailwind css • figma • storyblok
          </StyledDetailsParagraph>
        </StyledDetailsContainer>

        <StyledDetailsContainer>
          <StyledSummary>OTHERS</StyledSummary>
          <StyledDetailsParagraph>
            nodejs • nestjs • expressjs • mongodb • supabase • python • ml
          </StyledDetailsParagraph>
        </StyledDetailsContainer>
      </StyledDetailsWrapper>
    </Section>
  );
};

const StyledDetailsWrapper = styled.div`
  margin-top: 48px;
`;

const StyledDetailsContainer = styled.details`
  cursor: pointer;
  border-top: 1px solid ${({ theme }) => theme.colors.primaryText02};
  position: relative;
  overflow: hidden;
  transition: color 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.primaryText02};
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.highlightedText};
    z-index: -1;
    transform: scaleX(0);
    transform-origin: 0 50%;
    transition: transform 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
  }

  &[open] {
    color: ${({ theme }) => theme.colors.bg};
    summary {
      color: ${({ theme }) => theme.colors.bg};
    }
    &::after {
      transform: scaleX(1);
    }
  }
`;

const StyledSummary = styled.summary`
  font-weight: 900;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primaryText07};
  transition: color 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);

  @media (min-width: 335px) {
    font-size: 28px;
  }
  @media (min-width: 500px) {
    font-size: 32px;
  }
  @media (min-width: 750px) {
    font-size: 38px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
  }
`;

const StyledDetailsParagraph = styled.p`
  width: 90%;
  margin: 25px auto;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
`;

export default Skills;
